var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"color":"info","outlined":""},on:{"click":_vm.accessSignMode}},[_vm._v(" Proceso de firmas Inicial "),_c('v-icon',{staticClass:"ml-2",attrs:{"size":"18"}},[_vm._v("mdi-lock")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }